import randomColor from 'randomcolor';

export function getColor(str: string): string {
  return randomColor({
    luminosity: 'bright',
    seed: str,
  });
}
